import { Button, Container } from "@brightagency/headstart-common";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import React from "react";
import { UnstyledLink } from "../../atoms/UnstyledLink";
import { Outer, Inner, Title, Subtitle } from "./styled";

interface Props {
    title: string;
    subtitle: string;
    buttonText: string;
}

export const HeroNeedHelpNow: React.FC<Props> = props => {
    return (
        <Outer>
            <Container>
                <Inner>
                    <Title>{props.title}</Title>
                    <Subtitle>{props.subtitle}</Subtitle>
                    <UnstyledLink href="tel:000">
                        <Button maxWidth={250} iconBefore={<LocalPhoneRoundedIcon />}>
                            {props.buttonText}
                        </Button>
                    </UnstyledLink>
                </Inner>
            </Container>
        </Outer>
    );
};
